import React from "preact/compat";
import { currencyFormatter } from "../../../../helper/currencyFormatter";
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";
import { PartnerWagerProps } from "./partnerWager.type";

export const PartnerWager: React.FunctionComponent<PartnerWagerProps> = ({
  t,
  site,
  link,
  bet,
  wager,
  win,
  wagerId,
  disabled = false,
  onBlurWager,
  onInputWager
}) => {
    
    function resetValue(event: any) {
        event.target.value = ""
    }
    const brand = bet.sportsbookLogo ? bet.sportsbookLogo.replace("https://img.covers.com/betting/sportsbooks/bg-logos/", "").replace("_bg.svg","") : "";
    // bet.sportsbookLogo
    return (
        <div className="wager-card-partner d-flex justify-content-around align-items-stretch rounded w-100 bg-light">
            <div className={`partner-logo col-3 p-0 rounded-start d-flex align-items-center justify-content-center overflow-hidden bg-sb-${brand}`} style={{height: '70px'}}>
                {disabled ?
                    <img width="auto" height="45" src={bet.sportsbookLogo} style={{width: '100%'}} />
                :
                    <AffLink 
                        site={site}
                        className="p-0"
                        url={link}
                        aalink={`bet-slip-book-logo-click`}
                        type="link">
                        <img width="auto" height="45" src={bet.sportsbookLogo} style={{width: '100%'}} /> 
                    </AffLink>
                }
            </div>
            <div className="col-9 py-2 px-3 d-flex justify-content-between align-items-center">
                <div className="wager-card-wager col-6 pe-2 d-flex flex-column justify-content-start align-items-start">
                    <label className={`mb-1 ${site === 'covers' ? 'fs-8' : 'fs-9'} fw-normal`}>{t.wager_card.label}</label>
                    <input 
                        id={wagerId} 
                        className="form-control bs-input p-2 text-start rounded w-100 fs-8 fw-bold" 
                        type="text" 
                        name="currency-field" 
                        min="0" 
                        placeholder={wager} 
                        value={wager} 
                        data-type="currency" 
                        pattern="^\$\d{1,3}(,\d{3})*(\.\d{0,2})?$" 
                        onFocus={resetValue} 
                        onBlur={onBlurWager} 
                        onKeyUp={onInputWager} 
                        disabled={disabled}
                        style="line-height:16px;"  />
                </div>
                <div className={`wager-card-payout col-6 ps-2 d-flex flex-column justify-content-start align-items-start ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>
                    <span className="mb-1">{t.wager_card.payout}</span> 
                    <b className="fw-bolder w-100 shadow-sm bg-white rounded p-2">{win > 0 ? currencyFormatter.format(win) : currencyFormatter.format(0)}</b>
                </div>
            </div>
        </div>
    )
};